export const VOLTAGE_ALARM: string = 'VOLTAGE_ALARM'
export const ACTIVE_SERVICE: string = 'ACTIVE_SERVICE'
export const ACTIVE_LOW_OIL_ALARM: string = 'ACTIVE_LOW_OIL_ALARM'
export const ACTIVE_STATUS: string = 'ACTIVE_STATUS'
export const ACTIVE_STATUS_TRIGGER_ADDRESS: string = 'V20'
export const TIME_SENSOR_MODE_TRIGGER_ADDRESS: string = 'V30'
export const LOWER_DOSAGE_TRIGGER_ADDRESS: string = 'V40'
export const HIGHER_DOSAGE_TRIGGER_ADDRESS: string = 'V50'
export const ACTIVE_PRESSURE_ALARM: string = 'ACTIVE_PRESSURE_ALARM'
export const ACTIVE_TIME_MODE: string = 'ACTIVE_TIME_MODE'
export const ACTIVE_SERVICE_MODE: string = 'ACTIVE_SERVICE_MODE'
export const ACTIVE_REDUCED_DOSAGE: string = 'ACTIVE_REDUCED_DOSAGE'
export const ACTIVE_DIAGNOSTIC_MENU: string = 'ACTIVE_DIAGNOSTIC_MENU'
export const ACTIVE_PRESSURE_1_ERROR: string = 'ACTIVE_PRESSURE_1_ERROR'
export const ACTIVE_PRESSURE_2_ERROR: string = 'ACTIVE_PRESSURE_2_ERROR'
export const PASSAGE_COUNTER: string = 'PASSAGE_COUNTER'
export const ACTIVE_WHITE_BACKLIGHT: string = 'ACTIVE_WHITE_BACKLIGHT'
export const ACTIVE_RED_BACKLIGHT: string = 'ACTIVE_RED_BACKLIGHT'
export const REM_CHANGE_REGIME: string = 'REM_CHANGE_REGIME'
export const REM_LOWER_DOSAGE: string = 'REM_LOWER_DOSAGE'
export const REM_HIGHER_DOSAGE: string = 'REM_HIGHER_DOSAGE'
export const LIGHT: string = 'LIGHT'
export const PUMP: string = 'PUMP'
export const SIREN: string = 'SIREN'
export const OIL_LEVEL: string = 'OIL_LEVEL'
export const VOLTAGE: string = 'VOLTAGE'
export const INDICATION_ACTIVITY: string = 'INDICATION_ACTIVITY'
export const INDICATION_SENSOR_MODE: string = 'INDICATION_SENSOR_MODE'
export const INDICATION_TIME_MODE: string = 'INDICATION_TIME_MODE'
export const INDICATION_PUMP: string = 'INDICATION_PUMP'
export const INDICATION_SERVICE: string = 'INDICATION_SERVICE'
export const INDICATION_TRANSIT: string = 'INDICATION_TRANSIT'
export const INDICATION_LOWER_DOSAGE: string = 'INDICATION_LOWER_DOSAGE'
export const INDICATION_HIGHER_DOSAGE: string = 'INDICATION_HIGHER_DOSAGE'
export const SWITCH_ACTIVE: string = 'SWITCH_ACTIVE'
export const SWITCH_PUMP_MODE: string = 'SWITCH_PUMP_MODE'
export const SWITCH_OFF_PEAK_MODE: string = 'SWITCH_OFF_PEAK_MODE'
export const SWITCH_HIGH_PEAK_MODE: string = 'SWITCH_HIGH_PEAK_MODE'
export const TIMED_MODE_PUMP_TIME_WORK: string = 'TIMED_MODE_PUMP_TIME_WORK'
export const TIMED_MODE_PUMP_TIME_WAIT: string = 'TIMED_MODE_PUMP_TIME_WAIT'
export const SENSOR_MODE_PUMP_TIME_WORK: string = 'SENSOR_MODE_PUMP_TIME_WORK'
export const OFF_PEAK_PUMP_TIME_WORK: string = 'OFF_PEAK_PUMP_TIME_WORK'
export const OFF_PEAK_PUMP_TIME_WAIT: string = 'OFF_PEAK_PUMP_TIME_WAIT'
export const HIGH_PEAK_PUMP_TIME_WORK: string = 'HIGH_PEAK_PUMP_TIME_WORK'
export const HIGH_PEAK_PUMP_TIME_WAIT: string = 'HIGH_PEAK_PUMP_TIME_WAIT'
export const TIMED_MODE_WORKDAY_PUMP_TIME_ON: string = 'TIMED_MODE_WORKDAY_PUMP_TIME_ON'
export const TIMED_MODE_WORKDAY_PUMP_TIME_OFF: string = 'TIMED_MODE_WORKDAY_PUMP_TIME_OFF'
export const TIMED_MODE_TIMED_MODE_WEEKEND_PUMP_TIME_ON: string = 'TIMED_MODE_TIMED_MODE_WEEKEND_PUMP_TIME_ON'
export const TIMED_MODE_TIMED_MODE_WEEKEND_PUMP_TIME_OFF: string = 'TIMED_MODE_TIMED_MODE_WEEKEND_PUMP_TIME_OFF'
export const PUMP_EVERY_N_PASSAGE: string = 'PUMP_EVERY_N_PASSAGE'
export const PUMP_PASSAGE_DELAY: string = 'PUMP_PASSAGE_DELAY'
